import Admin from "../components/Admin/Admin"
import ContactMe from "../ContactUs/ContactMe"
import Home from "../components/Home/Home"
import NavbarContainer from "./NavbarContainer"
import PostContainer from "../components/postContainer/postContainer"
import { Routes, Route } from "react-router-dom"
import AboutUs from "../components/AboutUS/AboutUs"
import Footer from "../components/Footer/Footer"
import SinglePost from "../components/SinglePost/SinglePost"
import AllPost from "../components/AllPost/AllPost"
import ScrollToTop from "../components/ScrollTo/ScrollToTop"

const Index = () => {
  return (
    <>
      <div className="flex flex-col font-ivy-mode">
        <div className="backdrop-blur-sm md:h-24 h-20 flex w-full shadow-md shadow-secondary items-center fixed z-10 border-secondary">
          <NavbarContainer />
        </div>
          <ScrollToTop />
        <div className="pt-24">
          <Routes>
            <Route path="/" element={<Home />}>
              <Route path="/" element={<PostContainer />}>
                {/* <Route path="/" element={<ContactMe />}></Route> */}
              </Route>
            </Route>
            {/* <Route path="/contact-me" element={<ContactMe />} /> */}
            <Route path="/admin-vaishnavi" element={<Admin />} />
            <Route path="/about-me" element={<AboutUs />} />
            <Route path="/blogs" element={<AllPost />} />
            <Route path="/blog/:id" element={<SinglePost />} />
          </Routes>
          <ContactMe />
          <Footer />
        </div>
      </div>
    </>
  )
}

export default Index
